import { render, staticRenderFns } from "./ContenedorTableComponent.vue?vue&type=template&id=fdfcc04a&"
import script from "./ContenedorTableComponent.vue?vue&type=script&lang=js&"
export * from "./ContenedorTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports